<template>
  <div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>نام</th>
          <th
            v-for="(header, index) in headers"
            :key="index"
            scope="col"
            class="text-center"
          >
            <span class="text-success">{{ header.name }}</span
            ><br />{{ $lang.azmoonLang.report.build_date }}:
            {{ header.updated_at }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <th scope="row">{{ item.caption }}</th>
          <td
            class="text-center"
            v-for="(header, index) in headers"
            :key="index"
          >
            <div v-if="item.reports.find((x) => x.id == header.id)">
              <template
                v-for="(file, idx) in item.reports.find(
                  (x) => x.id == header.id
                ).files"
              >
                <a :key="idx" :href="file.url" target="_blank">
                  <img
                    :src="`/img/shared/file-icon/${file.type}.svg`"
                    width="30"
                    height="30"
                  />
                </a>
              </template>
            </div>
            <div v-else>گزارشی موجود نیست</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "table-report",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

